import React, { Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
import check from "../../assets/check.png";
import "../../components/UI Component/Modal/commonModals.css";

const SlugMessageSent = ({ show, okayClickHandler }) => {
  return (
    <Fragment>
      {show?<Modal
        show={show}
        onHide={okayClickHandler}
        centered
      >
        <button
          className=" border-0 bg-white text-right pr-3 pt-2 "
          onClick={okayClickHandler}
        >
          Close <span style={{ fontSize: "15px" }}>X</span>{" "}
        </button>

        <Modal.Body className="py-4 px-2">
          <div className="slug-message-sent">
            <div className="text-center align-items-center">
              <img
                src={check}
                alt="Success"
                style={{ width: "77px", height: "77px" }}
              />
              <p className="font-weight-bold my-1" style={{ fontSize: "25px" }}>
                Link Shared
              </p>
              <p className="mt-2 mb-3" style={{ fontSize: "15px" }}>
                Your Booking Appointment Link has been shared with the patient{" "}
              </p>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <Button
                className="border-0 rounded-pill "
                style={{
                  backgroundColor: "#17BAE0",
                  color: "#fff",
                  width: "140px",
                  height: "44px",
                }}
                onClick={okayClickHandler}
              >
                Okay
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>:null}
    </Fragment>
  );
};

export default SlugMessageSent;
